<script lang="ts">
  import SectionPrelevementDeliveryList from '@/generated/sections/SectionPrelevementDeliveryList.vue';
  import Delivery from '@/extend/classes/Delivery';
  import { DeliveryTypes } from '@/generated/classes/Delivery';
  import { ColumnFilter, ListChoix } from '@/extend/classes/ListData';
  import Button from '@/framework/base/classes/Button';
  import Files, { DownloadData } from '@/generated/classes/Files';
  import { getBlob } from '@/framework/files/helpers/FileTypes';
  import { defineComponent } from "vue";
  import { isProduction } from "@/framework/base/helpers/Environment";
  import { DateFormat, isValidDate } from "@/framework/base/helpers/DateFormat";
  import { ObjTypes } from '@/generated/classes/ObjTypes';

  export default defineComponent({
    components: {},
    extends: SectionPrelevementDeliveryList,
    data() {
      const buttons: Button[] = [];

      return {
        fileName: '',
        buttons
      };
    },
    computed: {
      pageLimit(): number {
        return 5;
      },
      canAdd(): boolean {
        return false;
      },
      extraButtons(): Button[] {
        if (this.buttons.length == 0) {
          const simu = new Button();
          simu.label = 'Générer';
          simu.show = true;
          simu.disabled = false;
          simu.outlined = true;
          simu.loading = false;
          simu.callback = () => this.generateCallback(simu);
          this.addButton(simu);
        }
        return this.buttons;
      },
      production(): boolean {
        return isProduction();
      }
    },
    methods: {
      addButton(button: Button) {
        this.buttons.push(button);
      },
      defaultFilter(): void {
        {
          const sortFilter = new ColumnFilter();
          sortFilter.name = "dateDelivery";
          sortFilter.sortDescending = true;
          this.activeFilters.push(sortFilter);

          const columnFilter = new ColumnFilter();
          columnFilter.name = "type";
          columnFilter.staticFilter = true;
          const b2b = new ListChoix();
          b2b.value = DeliveryTypes.PRELEVEMENT_B2B;
          columnFilter.filters.push(b2b);
          const b2c = new ListChoix();
          b2c.value = DeliveryTypes.PRELEVEMENT_B2C;
          columnFilter.filters.push(b2c);
          this.activeFilters.push(columnFilter);
        }
      },
      getDocumentColor(delivery: Delivery): string {
        if (delivery.xmlLoaded) {
          return '#1D6F42' // vert
        } else {
          return '#F40F02' // rouge
        }
      },
      mdiDocument(delivery: Delivery): string {
        return 'fas fa-code';
      },
      hasDocument(delivery: Delivery): boolean {
        return true;
      },
      getLabel(name: string, item: number, obj: unknown): string {
        let res = item == 0 || item == null ? '' : item.toString();
        if (name == 'ownerType') {
          res = ObjTypes[item];
        } else if (name == 'reference') {
          const delivery = obj as Delivery;
          res = delivery.reference + (delivery.type == DeliveryTypes.PRELEVEMENT_B2B ? " (B2B)" : " (B2C)");
        } else {
          const column = this.listConfig.find(a => a.name == name);
          if (column) {
            const choix = column.choix.find(a => a.value == item);
            if (choix) {
              res = choix.text;
            }
          }
        }
        if (isValidDate(res)) {
          res = new Date(res).toString()
        }
        return res;
      },
      displayDocument(delivery: Delivery): void {
        this.loading = true;
        const data = new DownloadData();
        data.service = 'Delivery';
        data.type.extension = 'xml';
        data.data = JSON.stringify(delivery);
        this.fileName = DateFormat.toFileName(delivery.dateDelivery.toString()) + ' ' + DeliveryTypes[delivery.type] + ' ' + delivery.id + '.xml';
        if (!this.actionProgress) {
          this.actionProgress = true;
          Files.download(data)
            .then((buffer) => {
              const blob = getBlob(buffer, data.type.extension);
              const file = window.URL.createObjectURL(blob);
              const docUrl = document.createElement('a');
              docUrl.setAttribute('href', file);
              docUrl.setAttribute('download', this.fileName);
              document.body.appendChild(docUrl);
              docUrl.click();
              this.actionProgress = false;
            }).catch(() => {
              this.actionProgress = false;
            });
        }
      },
      mdiAction(delivery: Delivery): string {
        return 'fas fa-landmark';
      },
      hasAction(delivery: Delivery): boolean {
        if (this.production) {
          return delivery.bankId > 0;
        } else {
          return true;
        }
      },
      getActionColor(delivery: Delivery): string {
        if (delivery.bankId > 0 && !delivery.hasReject) {
          return '#1D6F42' // vert
        } else if (delivery.bankId > 0) {
          return '#F40F02' // rouge
        } else {
          return '#1D4ED8' // bleu
        }
      },
      execAction(delivery: Delivery): void {
        if (!this.production) {
          this.actionProgress = true;
          Delivery.simuBank(delivery).then((res) => {
            delivery.bankId = res.bankId;
            this.actionProgress = false;
          }).catch(() => {
            this.actionProgress = false;
          });
        }
      },
      generateCallback(button: Button): void {
        if (!button.loading) {
          button.loading = true;
          Delivery.generatePrelevement().then((res) => {
            button.loading = false;
            this.reloadTable();
          }).catch(() => {
            button.loading = false;;
          })
        }
      }
    }
  })

</script>
